export enum EN_SPACE_TYPE {
  个人空间 = '1001144618640556032',
  企业空间 = '1001144677885100032',
  团队空间 = '1001144738807365632',
  项目空间 = '1001144787280936960',
  方案空间 = '1001144848207396864',
}

export enum EN_SPACE_PID {
  个人空间 = '1001804372618002432',
  企业空间 = '1001804489534226432',
}

export const BranchLibraryId = '1135871590661607424';
export const TagLibraryId = '1179117187982151680';
export const BomTagLibraryId = '1179117278595895296';
export const CostInfoTagLibraryId = '1278350907810238464';
export const PartTypeLibraryId = '946072180972761088';

// 图框默认标签表。与字典可新增项手工对齐（enabled 且非 compatibilityOnly），顺序同 DEFAULT_TAG_META。
// 停增项不进此列。成本信息表不在这里改。BOM 默认列见 BomTagLibrary。
export const TagLibrary = [
  { label: '项目名称', value: 'Project_name' },
  { label: '设备零件编号', value: '设备零件编号' },
  { label: '根节点名称', value: 'root_node_name' },
  { label: '单元零件编号', value: '单元零件编号' },
  { label: '部装图重量', value: '部装图重量' },
  { label: '父节点名称', value: 'parent_node_name' },
  { label: '零件编号（节点名称）', value: 'part_name' },
  { label: '实例名称', value: 'instanceName' },
  { label: '件号', value: 'part_code' },
  { label: '零件类型', value: 'partType' },
  { label: '材料', value: 'material' },
  { label: '热处理', value: 'heat_treatment' },
  { label: '表面处理', value: 'surface_treatment' },
  { label: '调质', value: 'quenching_tempering' },
  { label: '序号', value: 'index' },
  { label: '重量', value: 'mass' },
  { label: '装配关系索引数量', value: '装配关系索引数量' },
  { label: '左侧编号', value: 'left_part_name' },
  { label: '右侧编号', value: 'right_part_name' },
  { label: '对称编号', value: 'symmetry_part_name' },
  { label: '数量', value: 'unit_amount' },
  { label: '左侧数量', value: 'left_unit_amount' },
  { label: '右侧数量', value: 'right_unit_amount' },
  { label: '对称数量', value: 'symmetry_unit_amount' },
  { label: '子图图号', value: '子图图号' },
  { label: '子图零件名称', value: '子图零件名称' },
  { label: '子图材料', value: '子图材料' },
  { label: '长', value: 'length' },
  { label: '宽', value: 'width' },
  { label: '高', value: 'height' },
  { label: '厚度（料厚）', value: 'thickness' },
  { label: '型材长度', value: 'profile_length' },
  { label: '型号', value: 'model' },
  { label: '下料余量', value: '下料余量' },
  { label: '比例', value: 'scale' },
  { label: '图纸数量', value: 'drawing_amount' },
  { label: '当前页码', value: 'curSheet' },
  { label: '当前图纸页码', value: 'curDrawingSheet' },
  { label: '总页码', value: 'allSheet' },
  { label: '总图纸页码', value: 'allDrawingSheet' },
  { label: '工艺序号', value: 'legendIndex' },
  { label: '日期', value: 'yy_mm_dd' },
  { label: '基准左侧数量', value: '基准左侧数量' },
  { label: '基准右侧数量', value: '基准右侧数量' },
  { label: '对称左侧数量', value: '对称左侧数量' },
  { label: '对称右侧数量', value: '对称右侧数量' },
  { label: '索引数量（1X）', value: '索引数量(1X)' },
  { label: '外购件名称', value: '外购件名称' },
  { label: '标准件名称', value: '标准件名称' },
  { label: '左侧编号（德系）', value: '左侧编号（德系）' },
  { label: '右侧编号（德系）', value: '右侧编号（德系）' },
  { label: '分页名称（德系）', value: '分页名称（德系）' },
  { label: '装配圆柱销', value: '装配圆柱销' },
  { label: '装配销左侧数量', value: '装配销左侧数量' },
  { label: '装配销右侧数量', value: '装配销右侧数量' },
  { label: '装配螺钉', value: '装配螺钉' },
  { label: '装配螺钉左侧数量', value: '装配螺钉左侧数量' },
  { label: '装配螺钉右侧数量', value: '装配螺钉右侧数量' },
];

// BOM 默认标签表。字典可新增项里，应用场景包含 bom 的项。顺序同 DEFAULT_TAG_META。
// 字典没有「场景只有 BOM」的可增项。仅图框、仅索引的可增项不进此列。停增项不进此列。
export const BomTagLibrary = [
  { label: '项目名称', value: 'Project_name' },
  { label: '设备零件编号', value: '设备零件编号' },
  { label: '根节点名称', value: 'root_node_name' },
  { label: '单元零件编号', value: '单元零件编号' },
  { label: '部装图重量', value: '部装图重量' },
  { label: '父节点名称', value: 'parent_node_name' },
  { label: '零件编号（节点名称）', value: 'part_name' },
  { label: '实例名称', value: 'instanceName' },
  { label: '件号', value: 'part_code' },
  { label: '零件类型', value: 'partType' },
  { label: '材料', value: 'material' },
  { label: '热处理', value: 'heat_treatment' },
  { label: '表面处理', value: 'surface_treatment' },
  { label: '调质', value: 'quenching_tempering' },
  { label: '序号', value: 'index' },
  { label: '重量', value: 'mass' },
  { label: '左侧编号', value: 'left_part_name' },
  { label: '右侧编号', value: 'right_part_name' },
  { label: '对称编号', value: 'symmetry_part_name' },
  { label: '数量', value: 'unit_amount' },
  { label: '左侧数量', value: 'left_unit_amount' },
  { label: '右侧数量', value: 'right_unit_amount' },
  { label: '对称数量', value: 'symmetry_unit_amount' },
  { label: '子图图号', value: '子图图号' },
  { label: '子图零件名称', value: '子图零件名称' },
  { label: '子图材料', value: '子图材料' },
  { label: '长', value: 'length' },
  { label: '宽', value: 'width' },
  { label: '高', value: 'height' },
  { label: '厚度（料厚）', value: 'thickness' },
  { label: '型材长度', value: 'profile_length' },
  { label: '型号', value: 'model' },
  { label: '下料余量', value: '下料余量' },
  { label: '图纸数量', value: 'drawing_amount' },
  { label: '当前页码', value: 'curSheet' },
  { label: '当前图纸页码', value: 'curDrawingSheet' },
  { label: '总页码', value: 'allSheet' },
  { label: '总图纸页码', value: 'allDrawingSheet' },
  { label: '工艺序号', value: 'legendIndex' },
  { label: '日期', value: 'yy_mm_dd' },
  { label: '基准左侧数量', value: '基准左侧数量' },
  { label: '基准右侧数量', value: '基准右侧数量' },
  { label: '对称左侧数量', value: '对称左侧数量' },
  { label: '对称右侧数量', value: '对称右侧数量' },
  { label: '索引数量（1X）', value: '索引数量(1X)' },
  { label: '外购件名称', value: '外购件名称' },
  { label: '标准件名称', value: '标准件名称' },
  { label: '左侧编号（德系）', value: '左侧编号（德系）' },
  { label: '右侧编号（德系）', value: '右侧编号（德系）' },
  { label: '分页名称（德系）', value: '分页名称（德系）' },
  { label: '装配圆柱销', value: '装配圆柱销' },
  { label: '装配销左侧数量', value: '装配销左侧数量' },
  { label: '装配销右侧数量', value: '装配销右侧数量' },
  { label: '装配螺钉', value: '装配螺钉' },
  { label: '装配螺钉左侧数量', value: '装配螺钉左侧数量' },
  { label: '装配螺钉右侧数量', value: '装配螺钉右侧数量' },
];

// 成本信息标签表
export const CostInfoTagLibrary = [
  { label: 'NC面数量（个）', value: 'NC面数量（个）' },
  { label: '下料尺寸（长x宽x高）', value: '下料尺寸（长x宽x高）' },
  { label: '下料表面积（mm²）', value: '下料表面积（mm²）' },
  { label: '体积（mm³）', value: '体积（mm³）' },
  { label: '倒角尺寸（mm）及数量（个）', value: '倒角尺寸（mm）及数量（个）' },
  { label: '圆角尺寸（mm）及数量（个）', value: '圆角尺寸（mm）及数量（个）' },
  { label: '孔总数（个）', value: '孔总数（个）' },
  { label: '孔类型、孔径、孔数量、孔深度', value: '孔类型、孔径、孔数量、孔深度' },
  { label: '孔组信息', value: '孔组信息' },
  { label: '序号', value: 'index' },
  { label: '材料', value: 'material' },
  { label: '热处理', value: 'heat_treatment' },
  { label: '精加工面数量（个）', value: '精加工面数量（个）' },
  { label: '表面处理', value: 'surface_treatment' },
  { label: '零件名称', value: '零件名称' },
  { label: '零件数量（个）', value: '零件数量（个）' },
  { label: '零件类型', value: 'partType' },
  { label: '零件编号', value: 'part_name' },
];

// 零件类型表
export const PartTypeLibrary = [
  { label: '30-30连接件-抓手', value: '988462031020236800' },
  { label: '30-连接件-抓手', value: '988462244942323712' },
  { label: '50-30-连接件-抓手', value: '988462315424874496' },
  { label: '50-50连接件-抓手', value: '988462429911130112' },
  { label: '50-连接件-抓手', value: '988462534786973696' },
  { label: '80-30连接件-抓手', value: '988462622928805888' },
  { label: '80-50连接件-抓手', value: '988866084092411904' },
  { label: '80-80连接件-抓手', value: '988462782909415424' },
  { label: '80-连接件-抓手', value: '988462867075047424' },
  { label: 'TUENKERS型材', value: '971376858259451904' },
  { label: '主方管-抓手', value: '988463237553725440' },
  { label: '传感器', value: '946073693124210688' },
  { label: '传感器支架', value: '946073735197274112' },
  { label: '偏心销', value: '1001840721292046336' },
  { label: '光电开关', value: '1014169527649595392' },
  { label: '八角管连接件', value: '1001839013912522752' },
  { label: '副方管-抓手', value: '988463091537420288' },
  { label: '单导杆伸缩气缸', value: '946073935823417344' },
  { label: '单管BASE-抓手', value: '988462936412553216' },
  { label: '压块', value: '946073290743656448' },
  { label: '压臂', value: '946073973358243840' },
  { label: '叉车槽', value: '1001839238781980672' },
  { label: '双导杆伸缩气缸', value: '946074298869788672' },
  { label: '吊环', value: '1001839452314333184' },
  { label: '吸盘', value: '946074391182225408' },
  { label: '吸铁磁', value: '1001839406416064512' },
  { label: '圆管-抓手', value: '988463143200129024' },
  { label: '型材连接件', value: '1014169294115803136' },
  { label: '垫圈', value: '1014169614136143872' },
  { label: '垫片', value: '946073331428405248' },
  { label: '基准孔盖', value: '946074166694686720' },
  { label: '多管BASE-抓手', value: '988463007615057920' },
  { label: '定位销', value: '946073441700851712' },
  { label: '导向', value: '946074089527881728' },
  { label: '导套', value: '1014169568880463872' },
  { label: '导轨', value: '1001839583524171776' },
  { label: '弹簧', value: '1001840620306026496' },
  { label: '手动夹钳', value: '946073021729386496' },
  { label: '手柄', value: '1001838864112955392' },
  { label: '托块', value: '946073080583860224' },
  { label: '抓手BASE', value: '971376698913648640' },
  { label: '接地电极', value: '1001839082976169984' },
  { label: '摇臂铰链', value: '1001838955649445888' },
  { label: '方管焊接支座', value: '946074012281384960' },
  { label: '止动销', value: '1001840771514642432' },
  { label: '止推垫片', value: '1014169761771450368' },
  { label: '气缸连接块', value: '946073894979284992' },
  { label: '测试', value: '946073787680600064' },
  { label: '测试立柱专用', value: '974304702733713408' },
  { label: '滑板', value: '1014169707577708544' },
  { label: '滑轨气缸', value: '1001840827693387776' },
  { label: '滚轮', value: '1001840666355625984' },
  { label: '焊枪', value: '946074126857187328' },
  { label: '立柱', value: '946073198443802624' },
  { label: '立柱加强筋', value: '946073637272858624' },
  { label: '绝缘组件', value: '1001839171387666432' },
  { label: '缓冲器', value: '1001839304146350080' },
  { label: '缓冲垫', value: '1014169666090987520' },
  { label: '翻转气缸', value: '946073157637419008' },
  { label: '翻遍轴套', value: '1014169406535733248' },
  { label: '脚轮', value: '1001839493569171456' },
  { label: '行程开关', value: '1014169352869613568' },
  { label: '补高台', value: '946074229223370752' },
  { label: '衬套', value: '1001839641061634048' },
  { label: '角座', value: '946073369760149504' },
  { label: '轴套', value: '1014169853845671936' },
  { label: '轴承', value: '1001839539442274304' },
  { label: '连接块', value: '946073247013842944' },
  { label: '钩销缸', value: '946074350614917120' },
  { label: '铝型材', value: '1014598702188032000' },
  { label: '销座', value: '946073535921696768' },
  { label: '销缸支撑座', value: '946074054706769920' },
  { label: '限位块', value: '946073482121359360' },
];

export enum EN_CONFIG_TYPE {
  Enterprise = '企业配置',
  Branch = '品系配置',
}

export enum EN_TYPE_PID {
  企业配置 = EN_SPACE_PID.企业空间,
  品系配置 = BranchLibraryId,
}

export enum EN_TYPE_RESOURCECODE {
  企业品系 = 'standardBranchLibrary',
  品系配置 = 'standardBranchSetting',
}
